import { h } from 'preact';

import { IconTemplatePropsInterface } from './template-props.interface';

export const IconNotLoggedInState = (props: IconTemplatePropsInterface) => (
  <svg
    className={props.class}
    width='125'
    height='125'
    viewBox='0 0 110 110'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    {/* eslint-disable-next-line react/no-unknown-property */}
    <mask id='mask0' mask-type='alpha' maskUnits='userSpaceOnUse' x='0' y='0' width='110' height='110'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M55 110C85.3757 110 110 85.3757 110 55C110 24.6243 85.3757 0 55 0C24.6243 0 0 24.6243 0 55C0 85.3757 24.6243 110 55 110Z'
        fill='white'
      />
    </mask>
    <g mask='url(#mask0)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M55 110C85.3757 110 110 85.3757 110 55C110 24.6243 85.3757 0 55 0C24.6243 0 0 24.6243 0 55C0 85.3757 24.6243 110 55 110Z'
        fill='#FFF5F7'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M-21 12.8306L-7.86711 23.5392C-6.79634 24.4123 -5.45706 24.8891 -4.07544 24.8891H12.6069C13.9368 24.8891 15.2119 25.4189 16.1502 26.3614L27.9699 38.2333C29.0958 39.3642 30.626 40 32.2219 40H126C129.314 40 132 37.3137 132 34V23.819V-9H-21V12.8306Z'
        fill='#FBE9E0'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M19 -3.1694L32.1329 7.53916C33.2037 8.41227 34.5429 8.88908 35.9246 8.88908H52.6069C53.9368 8.88908 55.2119 9.4189 56.1502 10.3614L67.9699 22.2333C69.0958 23.3642 70.626 24 72.2219 24H166C169.314 24 172 21.3137 172 18V7.819V-25H19V-3.1694Z'
        fill='#F8D2C2'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M72 38.569C72 53.2426 60.1047 65.1379 45.431 65.1379C39.0647 65.1379 33.2213 62.8988 28.6455 59.1651C28.4488 59.4229 28.2174 59.6608 27.9521 59.8718L16.1101 69.289C14.381 70.664 11.8647 70.377 10.4897 68.648C9.11467 66.9189 9.40168 64.4026 11.1307 63.0276L22.9727 53.6104C23.0939 53.514 23.2188 53.4259 23.347 53.3458C20.5144 49.1208 18.8621 44.0378 18.8621 38.569C18.8621 23.8953 30.7574 12 45.431 12C60.1047 12 72 23.8953 72 38.569ZM66 38.569C66 49.9289 56.791 59.1379 45.431 59.1379C34.0711 59.1379 24.8621 49.9289 24.8621 38.569C24.8621 27.209 34.0711 18 45.431 18C56.791 18 66 27.209 66 38.569Z'
        fill='#77757A'
      />
      <path
        opacity='0.5'
        d='M50.6735 64.6208C62.8364 62.1867 72 51.448 72 38.569C72 23.8953 60.1047 12 45.431 12C42.6072 12 39.8863 12.4405 37.3332 13.2566C34.9676 16.1801 33.0913 19.5159 31.8289 23.1393C35.4545 19.9407 40.2161 18 45.431 18C56.791 18 66 27.209 66 38.569C66 49.9289 56.791 59.1379 45.431 59.1379C43.9426 59.1379 42.4911 58.9798 41.0924 58.6795C43.8992 61.1729 47.1343 63.1948 50.6735 64.6208Z'
        fill='#BBB8BD'
      />
      <path
        opacity='0.3'
        d='M70.5095 47.3646C68.7404 47.7802 66.8959 48 65 48C64.5748 48 64.1521 47.9889 63.7323 47.9671C65.1818 45.1501 66 41.9551 66 38.569C66 27.209 56.791 18 45.431 18C44.1467 18 42.8898 18.1177 41.6706 18.343C42.2129 16.0984 43.0707 13.977 44.1945 12.0283C44.6043 12.0095 45.0166 12 45.431 12C60.1047 12 72 23.8953 72 38.569C72 41.6516 71.475 44.6117 70.5095 47.3646Z'
        fill='#77757A'
      />
      <path
        d='M44.1449 24.817C44.5117 24.0737 45.5716 24.0737 45.9384 24.817L49.5235 32.0812C49.6692 32.3764 49.9508 32.5809 50.2765 32.6283L58.293 33.7932C59.1133 33.9123 59.4408 34.9203 58.8472 35.4988L53.0464 41.1533C52.8107 41.383 52.7032 41.714 52.7588 42.0384L54.1282 50.0226C54.2683 50.8395 53.4109 51.4625 52.6772 51.0768L45.507 47.3071C45.2157 47.154 44.8676 47.154 44.5763 47.3071L37.4061 51.0768C36.6725 51.4625 35.815 50.8395 35.9551 50.0226L37.3245 42.0384C37.3802 41.714 37.2726 41.383 37.0369 41.1533L31.2361 35.4988C30.6426 34.9203 30.9701 33.9123 31.7903 33.7932L39.8069 32.6283C40.1326 32.5809 40.4141 32.3764 40.5598 32.0812L44.1449 24.817Z'
        fill='#F3BF4F'
      />
      <path
        opacity='0.5'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M53.0231 43.5793C52.0626 43.8533 51.0484 44 50 44C43.9249 44 39 39.0751 39 33C39 32.9148 39.001 32.8298 39.0029 32.7451L39.8069 32.6282C40.1326 32.5809 40.4141 32.3763 40.5598 32.0812L44.1449 24.817C44.5117 24.0737 45.5716 24.0737 45.9384 24.817L49.5235 32.0812C49.6692 32.3763 49.9508 32.5809 50.2765 32.6282L58.293 33.7931C59.1133 33.9123 59.4408 34.9203 58.8472 35.4988L53.0464 41.1532C52.8107 41.383 52.7032 41.714 52.7588 42.0384L53.0231 43.5793Z'
        fill='#FFDB8C'
      />
      <rect x='72' y='64' width='23' height='21' fill='#F8D2C2' />
      <rect x='61' y='71' width='11' height='14' fill='url(#paint0_linear)' />
      <path d='M84 79.5C84 77.567 85.567 76 87.5 76C89.433 76 91 77.567 91 79.5V85H84V79.5Z' fill='#BDA0A0' />
      <path d='M76 77.5C76 76.6716 76.6716 76 77.5 76C78.3284 76 79 76.6716 79 77.5V81H76V77.5Z' fill='#FFFAE4' />
      <path d='M86 68.5C86 67.6716 86.6716 67 87.5 67C88.3284 67 89 67.6716 89 68.5V72H86V68.5Z' fill='#FFFAE4' />
      <path d='M65 77.5C65 76.6716 65.6716 76 66.5 76C67.3284 76 68 76.6716 68 77.5V81H65V77.5Z' fill='#FFFAE4' />
      <path d='M76 68.5C76 67.6716 76.6716 67 77.5 67C78.3284 67 79 67.6716 79 68.5V72H76V68.5Z' fill='#FFFAE4' />
      <rect x='71' y='62' width='25' height='2' fill='#BDA0A0' />
      <rect x='60' y='69' width='12' height='2' fill='#BDA0A0' />
      <rect width='14.6944' height='13.4167' transform='matrix(-1 0 0 1 28.3333 80.5833)' fill='#F8D2C2' />
      <rect width='7.02778' height='8.94444' transform='matrix(-1 0 0 1 35.3611 85.0556)' fill='url(#paint1_linear)' />
      <path
        d='M20.6667 90.4861C20.6667 89.2511 19.6655 88.25 18.4305 88.25C17.1956 88.25 16.1944 89.2511 16.1944 90.4861V94H20.6667V90.4861Z'
        fill='#BDA0A0'
      />
      <path
        d='M25.7778 89.2083C25.7778 88.6791 25.3487 88.25 24.8194 88.25C24.2902 88.25 23.8611 88.6791 23.8611 89.2083V91.4444H25.7778V89.2083Z'
        fill='#FFFAE4'
      />
      <path
        d='M19.3889 83.4583C19.3889 82.9291 18.9598 82.5 18.4305 82.5C17.9013 82.5 17.4722 82.9291 17.4722 83.4583V85.6944H19.3889V83.4583Z'
        fill='#FFFAE4'
      />
      <path
        d='M32.8055 89.2083C32.8055 88.6791 32.3765 88.25 31.8472 88.25C31.3179 88.25 30.8889 88.6791 30.8889 89.2083V91.4444H32.8055V89.2083Z'
        fill='#FFFAE4'
      />
      <path
        d='M25.7778 83.4583C25.7778 82.9291 25.3487 82.5 24.8194 82.5C24.2902 82.5 23.8611 82.9291 23.8611 83.4583V85.6944H25.7778V83.4583Z'
        fill='#FFFAE4'
      />
      <rect width='15.9722' height='1.27778' transform='matrix(-1 0 0 1 28.9722 79.3056)' fill='#BDA0A0' />
      <rect width='7.66667' height='1.27778' transform='matrix(-1 0 0 1 36 83.7778)' fill='#BDA0A0' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M-5.87571 99.2141H25.0712C25.0712 99.2141 28.5534 99.2524 31.3098 98.1655C34.0663 97.0786 37.0689 94.4834 37.0689 94.4834L41.1021 90.4548C41.1021 90.4548 44.4183 87.0486 47.2221 86.0349C50.026 85.0211 56.1893 85 56.1893 85L116 85V129.043H-6.00001L-5.87571 99.2141Z'
        fill='#D6C7C7'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M-13 107.255C-13 107.255 -10.0742 107.184 -7.54192 106.139C-5.00965 105.094 -3.37982 103.284 -3.37982 103.284L2.31654 97.5864C2.31654 97.5864 4.66823 95.1261 6.63014 94.1314C8.59205 93.1367 13.6054 93.252 13.6054 93.252H48.607C48.607 93.252 56.5341 93.1698 58.3619 94.1314C60.1896 95.0929 61.667 96.3469 61.667 96.3469L68.2983 102.754C68.2983 102.754 71.0153 105.375 73.0383 106.337C75.0613 107.298 80.6881 107.255 80.6881 107.255H106.458L106.827 115.088L-13 114.855L-13 107.255Z'
        fill='#E2D8D7'
      />
    </g>
    <defs>
      <linearGradient id='paint0_linear' x1='72' y1='72.0909' x2='61' y2='72.0909' gradientUnits='userSpaceOnUse'>
        <stop stopColor='#BDA0A0' />
        <stop offset='1' stopColor='#F8D2C2' />
      </linearGradient>
      <linearGradient id='paint1_linear' x1='7.02778' y1='0.69694' x2='0' y2='0.69694' gradientUnits='userSpaceOnUse'>
        <stop stopColor='#BDA0A0' />
        <stop offset='1' stopColor='#F8D2C2' />
      </linearGradient>
    </defs>
  </svg>
);
